export default {"src":"/_next/static/media/table-tennis.e0daacd1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};